<template>
  <!-- 选择支付方式 -->
  <div :class="'payTypeBox ' + uiType" v-if="payTypeShow">
    <div class="payType">
      <div class="payTypeTit flexSpBte">
        <span class="payTypeTitTxt"></span>
        <span class="payTypeTitTxt">选择支付方式</span>
        <img src="../assets/icon/shanchu1.png" @click="hide" />
      </div>
      <div class="topTitle">
        <img @click="showCancel = true" class="backImg" src="../assets/pingzi/back.png" alt="" />
        {{ $route.meta.title }}
      </div>
      <br />
      <!-- @click="radioChange" -->
      <div v-for="(item, index) in items" class="radio-group" @click="itemClick(item)" :key="index">
        <van-radio-group v-model="radio">
          <van-radio :disabled="!item.enable" :name="item.name" checked-color="#4FAE54">
            <div class="radios">
              <img :src="item.imgUrl" />
              <div class="flexDir typeDes" :class="item.enough ? '' : 'none'">
                <span class="">{{ item.value }}</span>
                <span class="typeDes2">额度不足</span>
              </div>
            </div>
          </van-radio>
        </van-radio-group>
      </div>
      <div v-if="items.length == 0" style="padding:10px;text-align:center">暂无支付方式，请联系代理商开通支付功能</div>
      <div class="payEnter btn bgBaseColor" hover-class="btnHover" @click="payfor">
        <span class="">确认支付：￥ {{ finalAmount.toFixed(2) }}</span>
      </div>
    </div>
    <!-- <van-overlay show="showOverLay">
      <van-loading size="24px">支付中...</van-loading>
    </van-overlay>-->
    <img v-if="showOverLay" @click="showCancel = true" class="cancel-icon" src="../assets/icon/shanchu2.png" />
    <van-popup class="apploading" :close-on-click-overlay="false" v-model="showOverLay">
      <van-loading size="24px" vertical>正在付款中...</van-loading>
    </van-popup>
    <!-- 放弃付款确认 -->
    <div class="cancelConfirm" v-if="showCancel">
      <div class="box">
        <div class="lists">
          <span class="">是否放弃付款？</span>
        </div>
        <div class="btn flexCenter">
          <span class="canlebtn" @click="showFail('用户放弃支付')">放弃</span>
          <span class="sussbtn" @click="showCancel = false">继续付款</span>
        </div>
      </div>
    </div>
    <!-- 支付失败满屏 -->
    <div class="container" v-if="showFailStatus" v-wechat-title="'支付失败'">
      <div class="topTitle show">
        <img @click="cancelPay" class="backImg" src="../assets/pingzi/back.png" alt="" />
        支付失败
      </div>
      <div style="width: 100%;height: 0.8rem;background: transparent;"></div>
      <img class="topImg" src="../assets/icon/paySuccess.png" />
      <!-- 顶部文字描述 -->
      <div class="topDes">
        <div class="topBox">
          <span class="">支付失败</span>
        </div>
        <span v-if="showFailReason">{{ showFailReason }}</span>
      </div>
      <!-- 按钮 -->
      <div class="btn1 btn bgBaseColor" hover-class="btnHover" @click="reset">
        <span>重新支付</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../services/api";
import util from "../utils/util";
import { Toast } from "vant";
import axiosp from "../utils/axiosp";
import { setTimeout } from "timers";
export default {
  name: "paytype",
  data() {
    return {
      items: [],
      // 原始模板
      itemsRaw: [],

      OrderType: "", //单据类型
      OrderId: "", //单据ID
      OrderCode: "", //支付单据
      Amount: 0, //单据支付金额

      payOrderId: 0, //查询支付订单支付状态

      showLimit: true, //是否显示额度支付
      payTypeShow: false, //是否显示支付方式
      checkLoop: false, //支付检查轮询

      radio: "", //已经选择的付款方式 ，绑定的是name

      showOverLay: false, //是否显示支付中的加载层
      showCancel: false, //是否显示取消付款的提示
      uiType: "default", //ui类型

      disabledItems: [], //禁用的项目
      showFailStatus: false,
      showFailReason: "",
      ExtData: null, //检测是否能够支付的状态判断
      ifLock: false, //如果加锁了
      Type:'',//出库的时候要传的值，销售结：20,销售开：63
      Id:'',
    };
  },
  created: function() {},
  computed: {
    finalAmount() {
      let amount = this.Amount;

      return amount > 0 ? parseFloat(amount.toFixed(2)) : 0;
    },
  },
  methods: {
    // 隐藏支付
    hide() {
      console.log("hide 销毁付款");
      this.reset();
      this.payTypeShow = false;
    },
    // 真正取消支付流程
    cancelPay() {
      this.$emit("cancelPay");
      this.hide();
    },
    // 获取支付类型
    async getPayType() {
      let result = await api.getPayType({ Platform: 13 });
      if (result.Data.length > 0) {
        this.itemsRaw = result.Data;
        this.itemsRaw.forEach((item, index) => {
          if (item.value == "支付宝") {
            item.imgUrl = require("../assets/pingzi/zhifubao.png");
            item.enable = true;
            item.enough = true;
          } else if (item.value == "微信") {
            item.imgUrl = require("../assets/icon/wxzf.png");
            item.enable = true;
            item.enough = true;
          } else if (item.value == "银联") {
            item.imgUrl = require("../assets/pingzi/yinlian.png");
            item.enable = true;
            item.enough = true;
          } else if (item.value == "额度支付") {
            item.imgUrl = require("../assets/icon/edzf.png");
          }
        });
      }
      //屏蔽微信支付
      // this.itemsRaw.forEach((item, index) => {
      //   if (item.value == "微信") {
      //     this.itemsRaw.splice(index, 1);
      //   }
      // });
    },
    //弹出支付失败界面
    showFail(msg) {
      console.log("showFail", msg);
      if (msg) {
        this.showFailReason = msg;
        // Toast(msg);
      } else {
        showFailReason = "";
      }
      this.reset();
      this.showFailStatus = true; //显示支付失败
    },
    reset() {
      // 重置状态
      this.checkLoop = false;
      this.showOverLay = false;
      this.showCancel = false;
      this.showFailStatus = false;
      window["payCallback"] = () => {
        console.log("payCallback");
      }; //重置
      if (this.ifLock) {
        console.log("第三方支付解锁");
        this.ifLock = false;
        //解锁
        let result = api.OrderPayLockUn({
          OrderType: this.OrderType,
          OrderId: this.OrderId,
        });
      }
    },
    // 项目点击
    itemClick(item) {
      if (item.enable == false && item.disabledTip) {
        Toast(item.disabledTip);
      }
    },
    async paySuccess() {
      Toast("支付成功！");
      if (this.ifLock) {
        console.log("第三方支付解锁");
        this.ifLock = false;
        //解锁
        let result = await api.OrderPayLockUn({
          OrderType: this.OrderType,
          OrderId: this.OrderId,
        });
      }
      // let res = await api.GetIsWarehouseOut({
      //   Type:this.Type,
      //   ObjId:this.OrderId
      // })
      api.GetIsWarehouseOut({
        Type:this.Type,
        ObjId:this.OrderId
      }).then((res) => {
          if(res.Data==1){
            let list;
            if(this.Type==20){
              list = [];
              list.push({
                id:this.OrderId
              })
              list = JSON.stringify(list)
            }else{
              list = this.OrderId;
            }
            api.GetStoreOutOrIn({
              Type:this.Type,
              IsReturnQuota:0,
              OrgId:sessionStorage.getItem("OrgId"),
              list:list
            }).then((res2)=>{
              setTimeout(() => {
                Toast(res2.Reason);
              }, 500);
            })
          }
      });
      
      this.$emit("paySuccess");
      setTimeout(() => {
        this.hide();
      }, 2000);
    },
    // 显示支付
    async show(options = {}) {
      console.log("showpay", options);
      //使用传入配置
      Object.keys(options).forEach((k) => {
        this[k] = options[k];
      });

      //深拷贝
      this.items = JSON.parse(JSON.stringify(this.itemsRaw));
      if (options.disabledItems) {
        this.items.forEach((item) => {
          if (options.disabledItems.includes(item.name)) {
            item.enable = false;
          }
        });
      }
      if (options.hideItems) {
        this.items.forEach((item, i) => {
          if (options.hideItems.includes(item.name)) {
            this.items.splice(i, 1);
          }
        });
      }

      this.getCiUsePrice();
      this.reset();
      this.payTypeShow = true;
    },
    //额度支付
    async limitPay() {
      // 额度支付
      let data = {
        OrderId: this.OrderId,
        OrderType: this.OrderType,
        PaymentMethodList: [
          {
            Method: 1,
            Amount: this.finalAmount,
          },
        ],
      };

      let res;

      try {
        res = await api.PayCredit(data);
      } catch (e) {
        console.error("支付失败", e);
        this.showFail(e || "系统繁忙，请稍后再试。");
        return;
      }

      if (!res) {
        res = {};
      }

      if (res.ResultType === 1) {
        this.paySuccess();
      } else {
        console.error("支付失败", res);
        this.showFail(res.Reason || "系统繁忙，请稍后再试。");
      }
    },
    // 调起原生支付
    callPayNative({ credential, payWay }) {
      console.log("callPayNative!!!!!!!!!!!!!!!!!", { credential, payWay });
      if (util.isAndroid()) {
        window.AndroidJS.pay(credential, payWay);
      } else {
        window.webkit.messageHandlers.pay.postMessage({
          data: credential,
          payWay,
        });
      }
    },

    // 拉卡拉支付
    callLaKaLaPay(url) {
      console.log("callLaKaLaPay");
      if (util.isAndroid()) {
        window.AndroidJS.unionPay(url);
      } else {
        window.location.href = url;
      }
    },
    // 支付
    async payfor() {
      let currPayType = this.radio;
      console.log("currPayType", currPayType);

      if (currPayType == "") {
        Toast("请选择支付方式");
        return;
      }

      if (this.finalAmount <= 0) {
        Toast("暂不支持零元支付，请调整组合后再支付");
        return;
      }

      try {
        Toast.loading({
          message: "检测支付环境",
          duration: 0, // 持续展示 toast
          forbidClick: true,
        });
        
        let canPayStatus = await api.checkCanPay({
          OrderType: this.OrderType,
          OrderId: this.OrderId,
          ExtData: this.ExtData,
        });

        if (canPayStatus !== true) {
          Toast.clear();
          Toast(canPayStatus || "检测到订单状态发生变化，暂不可支付，请您刷新后再次尝试。");
          return;
        }

        if (this.OrderType == 20 /** 结算 */ || this.OrderType == 43 /** 开单 */ || this.OrderType == 64 /** 还款 */) {
          //第三方支付加锁
          let result = await api.OrderPayLock({
            OrderType: this.OrderType,
            OrderId: this.OrderId,
          });
          this.ifLock = true;
        }
        Toast.clear();
      } catch (e) {
        console.error(e);
        Toast.clear();
        Toast(e || "系统繁忙，请稍后再试");
        return;
      }

      this.showOverLay = true;

      if (currPayType == "limit") {
        this.limitPay();
        return;
      }
      var Pay_Platform = 0;
      // if (currPayType == "aplipay") {
      //   Pay_Platform = 0;
      // } else if (currPayType == "wechat") {
      //   Pay_Platform = 1;
      // } else if (currPayType == "union") {
      //   Pay_Platform = 2;
      // }
      this.items.forEach((item, index) => {
        if (currPayType == item.name) {
          Pay_Platform = item.id;
        }
      });
      console.log(Pay_Platform);
      let data = {
        Eshop_Mobile:api.getMobile(),
        RepaymentOrderId: this.OrderCode,
        ADS_OrderId: this.OrderId,
        Pay_Platform: Pay_Platform,
        PayAmount: this.finalAmount,
        OrderType: this.OrderType,
        CouponIds: this.selectedCoupon ? [this.selectedCoupon.RecordId].join(",") : "",
        DMSCode: api.getDMSCode(),
        ShopCode: api.getShopCode(),
        ...util.getStoObj("Eshop_login"),
        PlatformType: 13, //TODO
      };

      let datas;
      try {
        datas = await axiosp.payforReqPost("Ca_AcProducts/PayRepaymentOrder", data);
        let _orderId = datas.Data.WxPayInfo.orderId;
        if(_orderId && datas.ResultType==1){
          wx.miniProgram.navigateTo({
            url: `../pay/pay?orderId=${_orderId}`,
          });

          setTimeout(()=>{
            this.checkStatus(_orderId);
          },5000)
        }
      } catch (error) {
        console.error(error);
        this.showFail("创建支付订单时系统繁忙，请稍后再试");
        return;
      }

      let res = datas.Data;

      try {
        if (!res.ADS_OrderId) {
          this.showFail(datas.Message || "订单号异常");
          return;
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 查询额度
    getCiUsePrice() {
      api.GetCredit().then((res) => {
        this.creditMoney = res;
        this.items.forEach((item) => {
          if (item.name == "limit") {
            item.value = `额度支付(剩余：￥${this.creditMoney.HasCreditMoney})`;
            if (this.Amount > this.creditMoney.HasCreditMoney) {
              item.enough = false;
              item.enable = false;
            } else {
              item.enough = true;
              item.enable = true;
            }
          }
        });
      });
    },
    // 用户点击确认支付的时的函数调用
    checkStatus(OrderId) {
      console.log("checkStatus", OrderId);
      this.checkLoop = true;
      axiosp
        .payforReqPost("Ca_AcProducts/LaKaLa_QueryOrder", {
          orderId: OrderId.toString().replace("QPT", ""),
        })
        .then((res) => {
          console.log("支付状态检查", res.Data.OrderStatus);
          if (res.Data.OrderStatus != 1) {
            // TODO: 改为对时间的判断
            if (this.checkLoop) {
              if (res.Message && res.Message != "ok" && res.Message != "订单号异常") {
                console.error(res.Message);
                this.showFail(res.Message);
              } else {
                if (this.checkLoop) {
                  setTimeout(() => {
                    this.checkLoop && this.checkStatus(OrderId);
                  }, 3000);
                }
              }
            } else {
              //支付不成功
              console.error("支付不成功");
              this.showFail("支付不成功");
            }
          } else {
            this.paySuccess();
          }
        })
        .catch((err) => {
          console.error(err);
          this.showFail("支付不成功");
        });
    },
  },
  async mounted() {
    console.log("mounted");
    this.getPayType();
  },
  beforeDestroy() {
    this.reset();
  },
};
</script>

<style lang="scss" scoped>
.payTypeBox .payType .radio-group {
  height: 1rem !important;
}

.radios {
  width: 6rem;
  display: flex;
  align-items: center;

  img {
    margin-right: 0.3rem;
  }
}

// 半屏显示
.payTypeBox.default {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0%;
  left: 0%;
  z-index: 11;

  // 不显示顶部标题
  .topTitle {
    display: none;
  }

  .payType {
    position: fixed;
    padding: 0.2rem 0.3rem;
    box-sizing: border-box;
    bottom: 0;
    left: 0%;
    width: 100%;
    background: #fff;
    border-radius: 0.6rem 0.6rem 0 0;
    font-size: 0.3rem;
    // text-align: center;

    .payTypeTit {
      font-size: 0.32rem;
      text-align: left;
      margin-bottom: 0.2rem;
      color: #1c1c1c;
      font-weight: bold;

      img {
        width: 0.3rem;
        height: 0.3rem;
        padding: 0.2rem;
      }
    }

    .radio-group {
      height: 1.5rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: left;

      img {
        width: 0.5rem;
        height: 0.5rem;
      }

      .radio {
        width: 100%;
      }

      .typeDes {
        width: 70%;
        text-align: left;
      }

      .none {
        color: #888888;

        .typeDes2 {
          display: block;
        }
      }

      .typeDes2 {
        font-size: 0.24rem;
        display: none;
      }
    }
  }

  .payEnter {
    width: 100%;
    line-height: 0.8rem;
    height: 0.8rem;
    border-radius: 0.15rem;
    color: #fff;
    margin: 0.5rem auto 0.2rem auto;
  }
}

// 满屏显示
.payTypeBox.full {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0%;
  left: 0%;
  z-index: 2000;

  .payType {
    position: fixed;
    box-sizing: border-box;
    // top: 0.8rem;
    top: 0;
    bottom: 0;
    left: 0%;
    width: 100%;
    background: #fff;
    font-size: 0.3rem;
    // text-align: center;
    height: 100%;

    .payTypeTit {
      font-size: 0.32rem;
      text-align: left;
      color: #1c1c1c;
      font-weight: bold;

      img {
        width: 0.3rem;
        height: 0.3rem;
        padding: 0.2rem;
      }
    }

    .radio-group {
      height: 1.5rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #e6e6e6;

      img {
        width: 0.5rem;
        height: 0.5rem;
      }

      .radio {
        width: 100%;
      }

      .typeDes {
        width: 70%;
        text-align: left;
      }

      .none {
        color: #888888;

        .typeDes2 {
          display: block;
        }
      }

      .typeDes2 {
        font-size: 0.24rem;
        display: none;
      }
    }
  }

  .payEnter {
    flex: 1;
    line-height: 0.8rem;
    height: 0.8rem;
    border-radius: 0.15rem;
    color: #fff;
    margin: 0.5rem auto 0.2rem auto;
    position: fixed;
    bottom: 0;
    margin: 0 0.3rem;
    margin-bottom: 0.3rem;
    width: calc(100% - 0.6rem);
  }
}
.apploading {
  .van-loading {
    width: 2.33rem;
    height: 2.33rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .van-loading__spinner {
    width: 1.2rem;
    height: 1.2rem;
  }
  .van-loading__text {
    font-size: 0.3rem;
  }
}

// 取消付款确认
.cancelConfirm {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 10000;
  position: fixed;
  top: 0;
  left: 0;
  .box {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 7rem;
    height: 4rem;
    background: #fff;
    z-index: 11;
    text-align: center;
    font-size: 0.28rem;
    border-radius: 0.12rem;
    margin: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .tit {
      margin-bottom: 0.8rem;
    }
    .lists {
      padding: 0.2rem;
      box-sizing: border-box;
      font-size: 0.36rem;
      color: #1c1c1c;
      font-weight: bold;
      margin-bottom: 1.08rem;
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
      .red {
        color: #e64340;
      }
      .grays {
        color: #888;
      }
    }
    .bobotm {
      border-bottom: 1px solid #f5f5f5;
    }
  }
}
.canlebtn {
  width: 2.05rem;
  height: 0.68rem;
  border: 2px solid rgba(79, 174, 84, 1);
  border-radius: 0.34rem;
  display: inline-block;
  color: rgba(79, 174, 84, 1);
  line-height: 0.68rem;
  font-size: 0.3rem;
  margin-right: 0.3rem;
}
.sussbtn {
  width: 2.05rem;
  height: 0.68rem;
  background: rgba(79, 174, 84, 1);
  border: 2px solid rgba(79, 174, 84, 1);
  border-radius: 0.34rem;
  display: inline-block;
  color: #fff;
  font-size: 0.3rem;
  line-height: 0.68rem;
}
.cancel-icon {
  position: fixed;
  top: 0.2rem;
  left: 0.2rem;
  z-index: 10000;
}

.container {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  // padding: 0.15rem;
  background-color: white;

  z-index: 12;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  .topTitle.show {
    display: block;
  }

  .topImg {
    width: 100%;
    height: 2.66rem;
  }

  .topDes {
    box-sizing: border-box;
    font-size: 0.38rem;
    // background: #f5f5f5;
    color: #383838;
    text-align: center;
    .topBox {
      width: 2.2rem;
      height: 0.3rem;
      margin: 0.5rem auto;
      img {
        width: 0.3rem;
        height: 0.3rem;
        margin-right: 0.3rem;
      }
    }
  }

  .btn1 {
    width: 6rem;
    height: 0.8rem;
    line-height: 0.8rem;
    color: #fff;
    margin: 2rem auto 0.5rem auto;
  }

  .btn2 {
    width: 5.96rem;
    height: 0.76rem;
    line-height: 0.8rem;
    color: #4fae54;
    box-sizing: border-box;
    margin: 0.2rem auto 1rem auto;
    border: 0.02rem solid #4fae54;
  }
}
</style>
